import React from 'react'

const StarsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_117_21269"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_117_21269)">
        <path
          d="M12 14.95L14.775 17.05C14.975 17.2 15.175 17.2083 15.375 17.075C15.575 16.9417 15.6333 16.7583 15.55 16.525L14.5 13.05L17.225 11.1C17.425 10.9667 17.4877 10.7833 17.413 10.55C17.3377 10.3167 17.175 10.2 16.925 10.2H13.6L12.475 6.55C12.3917 6.31667 12.2333 6.2 12 6.2C11.7667 6.2 11.6083 6.31667 11.525 6.55L10.4 10.2H7.075C6.825 10.2 6.66267 10.3167 6.588 10.55C6.51267 10.7833 6.575 10.9667 6.775 11.1L9.5 13.05L8.45 16.525C8.36667 16.7583 8.425 16.9417 8.625 17.075C8.825 17.2083 9.025 17.2 9.225 17.05L12 14.95ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z"
          fill="#CCCFD6"
        />
      </g>
    </svg>
  )
}

export default StarsIcon
